@use "@fukuri-admins/ui/layout" as *;

.darkRoot {
  cursor: pointer;
  text-decoration: none;
  display: flex;
  flex-wrap: nowrap;
  width: fit-content;
  justify-content: center;
  align-items: center;
  background: $Button;
  border-radius: 10px;
  transition: all 0.2s ease-out;
  padding: 10px 48px;
  text-decoration: none;
  i {
    margin-left: 5px;
    font-size: 13px;
    line-height: 16px;
    color: #fff;
  }
  &:hover {
    background: $ButtonHover;
  }
  @media (max-width: 540px) {
    padding: 12px 24px;
    p {
      font-size: 12px;
    }
  }
  @media (max-width: 400px) {
    padding: 8px 10px;
    p {
      font-size: 10px;
    }
  }
}

.lightRoot {
  cursor: pointer;
  text-decoration: none;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  width: fit-content;
  align-items: center;
  background: $ButtonLightGray;
  border-radius: 10px;
  padding: 10px 48px;
  transition: all 0.2s ease-out;
  i {
    margin-left: 5px;
    font-size: 13px;
    line-height: 16px;
    color: #000;
  }
  &:hover {
    background: $ButtonLightGrayHover;
  }
  @media (max-width: 540px) {
    padding: 12px 24px;
    p {
      font-size: 12px;
    }
  }
  @media (max-width: 400px) {
    padding: 8px 10px;
    p {
      font-size: 10px;
    }
  }
}

.darkDes {
  color: #000;
  font-family: "Noto Sans JP";
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.05em;
  line-height: 1.9;
  margin: 0;
  word-break: keep-all;
}

.lightDes {
  color: #fff;
  font-family: "Noto Sans JP";
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.05em;
  line-height: 1.9;
  margin: 0;
  word-break: keep-all;
}

.disable {
  opacity: 0.7;
  cursor: no-drop;

  &:hover {
    box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.2) !important;
    transform: translate(0px, 0px) !important;
  }
}

.noDisable {
  opacity: 1;
}
